import { subscribers } from '../internal/messagingContainer';
export var emitMessage = function (message) {
    subscribers.forEach(function (s) {
        s.name === message.name && s.onNewMessage(message.payload);
    });
};
export var off = function (subscriber) {
    var subIndex = subscribers.indexOf(subscriber);
    subscribers.splice(subIndex, 1);
};
export var subscribe = function (name, onNewMessage) {
    var subscriber = { name: name, onNewMessage: onNewMessage };
    subscribers.push(subscriber);
    return subscriber;
};
//# sourceMappingURL=subscription.js.map